<button pso-button color="supporting-5-light-blue" size="s" [disabled]="disabled" [style.margin.px]="0">
  <ng-content></ng-content>
  <wchfs-icon svgIcon="pso-legacy:arrow-form-right" color="white" size="16"></wchfs-icon>
</button>
